import { Dispatch } from "react";
import { MixPuzzleInstrument } from "shared/games/mixpuzzles/types";
import Button from "ui/atoms/Button/Button";
import prettyInstrument from "util/formatters/prettyInstrument";
import SubControlBar from "../atoms/SubControlBar";
import Action from "../state/actions";

interface Props {
  instrument: MixPuzzleInstrument;
  dispatch: Dispatch<Action>;
}

export default function DesktopPatchedInControlBar({
  instrument: { instrument },
  dispatch,
}: Props) {
  return (
    <SubControlBar>
      <div className="flex w-full items-center justify-between">
        <h2 className="z-10 mr-2 font-brik text-4xl leading-none">
          Patched In:{" "}
          <span className="text-purple-400">
            {prettyInstrument(instrument)}
          </span>
        </h2>

        <Button
          theme="red"
          outline
          onClick={() => dispatch({ type: "startover" })}
        >
          Start over
        </Button>
      </div>
    </SubControlBar>
  );
}
